import uniqid from 'uniqid'

export const getGUID = () => {
    const uid = uniqid(uniqid.process())
    return uid
}
